import { useEffect, useState } from "react"

export default function useReRender(delayMs) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCount(t => t + 1), delayMs);
    return () => clearInterval(timer);
  }, [delayMs]);

  return count;
}